import React from 'react'
import { Sparkles, Plus } from 'lucide-react'
import { useTheme } from '@/context/ThemeContext'

type Props = {
  onCreateWithZeph: () => void
  onCreateManually: () => void
}

// Zeph is the primary path (filled, first) and the manual builder the fallback
// (outlined) — the product goal is getting a campaign out fast with AI.
const CreateCampaignActions: React.FC<Props> = ({ onCreateWithZeph, onCreateManually }) => {
  const { currentTheme: t } = useTheme()

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <button
        type="button"
        onClick={onCreateWithZeph}
        className="flex items-center gap-1.5 h-9 px-3.5 rounded-lg text-sm font-semibold"
        style={{ background: t.accentGradient ?? t.accent, color: t.buttonText }}
      >
        <Sparkles size={15} />
        Create with Zeph
      </button>
      <button
        type="button"
        onClick={onCreateManually}
        className="flex items-center gap-1.5 h-9 px-3.5 rounded-lg text-sm font-medium"
        style={{ backgroundColor: 'transparent', color: t.text, border: `1px solid ${t.border}` }}
      >
        <Plus size={15} />
        Create manually
      </button>
    </div>
  )
}

export default CreateCampaignActions
